import IconUI from '../icon/IconUI';

// Pages shown adjacent to the current page on each side.
const SIBLINGS = 1;

// Page numbers to render, e.g. [1, 'ellipsis', 4, 5, 6, 'ellipsis', 12].
function getPageItems(current, total) {
  if (total <= 5 + SIBLINGS * 2) {
    return Array.from({ length: total }, (_, i) => i + 1);
  }

  const start = Math.max(2, current - SIBLINGS);
  const end = Math.min(total - 1, current + SIBLINGS);

  return [
    1,
    start > 2 ? 'ellipsis' : null,
    ...Array.from({ length: end - start + 1 }, (_, i) => start + i),
    end < total - 1 ? 'ellipsis' : null,
    total,
  ].filter(Boolean);
}

export default function Pagination({ currentPage, totalPages, onPageChange }) {
  if (!totalPages || totalPages <= 1) return null;

  return (
    <nav className="Pagination" aria-label="Pagination">
      <button
        type="button"
        className="Pagination-button Pagination-arrow"
        aria-label="Previous page"
        disabled={currentPage <= 1}
        onClick={() => onPageChange(currentPage - 1)}
      >
        <IconUI icon="chevronLeft" />
      </button>

      {getPageItems(currentPage, totalPages).map((item, i) =>
        item === 'ellipsis' ? (
          <span
            key={`ellipsis-${i}`}
            className="Pagination-ellipsis"
            aria-hidden="true"
          >
            &hellip;
          </span>
        ) : (
          <button
            key={item}
            type="button"
            className={`Pagination-button Pagination-page ${
              item === currentPage ? 'isCurrent' : ''
            }`}
            aria-label={`Page ${item}`}
            aria-current={item === currentPage ? 'page' : undefined}
            onClick={() => item !== currentPage && onPageChange(item)}
          >
            {item}
          </button>
        )
      )}

      <button
        type="button"
        className="Pagination-button Pagination-arrow"
        aria-label="Next page"
        disabled={currentPage >= totalPages}
        onClick={() => onPageChange(currentPage + 1)}
      >
        <IconUI icon="chevronRight" />
      </button>
    </nav>
  );
}
